import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import type { UseErrorModalReturn } from '@percent/domain/giving'

export type CancelCampaignFailureModalProps = Pick<UseErrorModalReturn, 'isOpen' | 'errorMsg' | 'closeModal'>

export function CancelCampaignFailureModal({ isOpen, errorMsg, closeModal }: CancelCampaignFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={closeModal} aria-labelledby="cancel-campaign-failure">
      <AcknowledgeModal
        result="negative"
        title={t('workplace_giving.myCampaigns.actions.cancelErrorModal.title')}
        description={errorMsg}
        buttonText={t('workplace_giving.common.close')}
        handleClose={closeModal}
      />
    </Modal>
  )
}
